module.exports = __webpack_public_path__ + "assets/src/style/img/footer-interreg.png?84eb72e83386dd0d148f3e34e7d57e7d";